import * as React from "react";
import { useTranslation } from "react-i18next";
import QueryHelper from "components/common/QueryHelper";
const EXAMPLE_QUERY = "email:example.com";
const UserQueryHelper = () => {
  const { t } = useTranslation("users");
  const queryExample = /* @__PURE__ */ React.createElement("p", null, t("users_list.query_example"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, EXAMPLE_QUERY), /* @__PURE__ */ React.createElement("br", null));
  const fieldMap = {
    full_name: t("users_list.fields.full_name"),
    username: t("users_list.fields.username"),
    email: t("users_list.fields.email")
  };
  return /* @__PURE__ */ React.createElement(QueryHelper, { example: queryExample, commonFields: [], fieldMap, entityName: "user" });
};
export default UserQueryHelper;
